/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';

import { takeWhile } from 'rxjs/operators';
import { NbAuthService } from '@nebular/auth';
import * as moment from 'moment';

@Component({
  selector: 'nb-auth',
  // styleUrls: ['./auth.component.scss'],
  template: `
     <nb-layout>
       <nb-layout-column class="d-flex align-items-center text-center">
         <nb-card class="border-0 box mx-auto" style="width:37em">
           <!--<nb-card-header>
             <nav class="navigation">
               <a href="#" (click)="back()" class="link back-link" aria-label="Back">
               </a>
             </nav>
           </nb-card-header>-->
           <nb-card-body class="align-items-cen">
             <nb-auth-block>
               <router-outlet></router-outlet>
             </nb-auth-block>
           </nb-card-body>
         </nb-card>
       </nb-layout-column>
     </nb-layout>
   `,
})
export class NbAuthPatchComponent implements OnDestroy {

  private alive = true;

  subscription: any;

  authenticated: boolean = false;
  token: string = '';

  // showcase of how to use the onAuthenticationChange method
  constructor(public auth: NbAuthService, protected location: Location) {

    this.subscription = auth.onAuthenticationChange()
      .pipe(takeWhile(() => this.alive))
      .subscribe((authenticated: boolean) => {
        this.authenticated = authenticated;
        localStorage.setItem('session_time', ''+moment().utc().unix());
      });
  }

  back() {
    this.location.back();
    return false;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
